import { Building2, Phone, FileText, CheckCircle, Circle, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProfileItem {
  key: string;
  label: string;
  completed: boolean;
}

interface ProfileCompletionProps {
  profileCompletion: {
    percentage: number;
    items: ProfileItem[];
  };
}

const iconMap: Record<string, JSX.Element> = {
  company_details: <Building2 className="w-4 h-4" />,
  contact_information: <Phone className="w-4 h-4" />,
  w9_tax_form: <FileText className="w-4 h-4" />,
  insurance_certificate: <FileText className="w-4 h-4" />
};

export function ProfileCompletion({ profileCompletion }: ProfileCompletionProps) {
  const { items = [], percentage = 0 } = profileCompletion || {};
const navigate = useNavigate()
  return (
    <div className="dashboard-panel profile-panel bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <h3 className="font-[500] text-gray-900 mb-5 tracking-tight">
        Complete Your Profile
      </h3>

      {/* Progress */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-2.5">
          <span className="text-xs font-medium text-gray-600 uppercase tracking-wide">
            Progress
          </span>
          <span className="text-xs font-bold text-gray-900">
            {percentage}%
          </span>
        </div>
        <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
          <div
            className="bg-indigo-600 h-2.5 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>

      {/* Checklist */}
      <div className="space-y-3.5 mb-6">
        {items.map((item) => (
          <div key={item.key} className="flex items-center gap-3 group">
            {item.completed ? (
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0" />
            ) : (
              <Circle className="w-5 h-5 text-gray-300 flex-shrink-0 group-hover:text-gray-400 transition-colors" />
            )}

            <div className="flex items-center gap-2.5 flex-1">
              <span className={item.completed ? 'text-gray-400' : 'text-gray-600'}>
                {iconMap[item.key] ?? <FileText className="w-4 h-4" />}
              </span>

              <span
                className={`text-sm font-medium ${
                  item.completed
                    ? 'text-gray-400 line-through'
                    : 'text-gray-700'
                }`}
              >
                {item.label}
              </span>
            </div>
          </div>
        ))}
      </div>

      <button onClick={()=>{
navigate("/pages-profile-settings")
      }} className="profile-completion-action">
        <span>Finish profile setup</span>
        <ArrowRight size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
